export default "__VITE_ASSET__CxghUo9a__"